module.exports = __webpack_public_path__ + "static/img/class-schedule.7d9c3ca3.png";